import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dimmer } from "semantic-ui-react";
import Table from "../../../components/Table/Table";
import { editActions } from "../../../actions/editActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import EditKCEVersionCommon from "../../Editing/EditVersionCommon";
import { pdApiActions } from "../../../actions/pdApiActions";
import * as _ from "lodash";

export type VPProps = {
  columns: State.ColumnMap;
  rows: Api.AnyVP[];
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  subMenuRoute: string;
  toggleModal: () => void;
  columnFilters?: Filter[];
  setColumnFilters: (subMenuRoute: string, columnFilter: Filter[]) => void;
};

const DoorVersion: React.FC<VPProps> = ({
  columns,
  rows,
  mainState,
  editedObjectId,
  isEditActive,
  editActions,
  subMenuRoute,
  toggleModal,
  setColumnFilters
}) => {
  const { editSize, pageSize, isShortenTextEnabled } = mainState;

  // Debounced filter change handler
  const handleFilterChangeDebounced = useCallback(
    _.debounce((changedFilters: Filter[]) => {
      setColumnFilters(subMenuRoute, changedFilters);
    }, 500),
    [setColumnFilters, subMenuRoute]
  );
  const isLoading = useSelector((state: State.Root) => state.loadingStatus.isLoadingDoorBindings);

  // Check if a row is selected
  const isSelected = useCallback(
    (vp: Api.DoorVersion): boolean => editedObjectId === vp.versionId,
    [editedObjectId]
  );

  const pdApi = useSelector((state: State.Root) => state.pdApi);
  const dispatch = useDispatch();

  // Cleanup debounce on unmount
  useEffect(() => () => handleFilterChangeDebounced.cancel(), [handleFilterChangeDebounced]);

  useEffect(() => {
    if (pdApi[subMenuRoute.split(" ").join("") as keyof State.PdApi] === undefined) {
      dispatch(pdApiActions.fetchDoorBindings(subMenuRoute));
    }
  }, [subMenuRoute, dispatch]);

  const selectedColumns = columns[subMenuRoute as keyof State.ColumnMap];

  return (
    <div className="table-container">
      <div className="flex-1">
        <div className="flex-1">
          <Table
            rows={rows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={row => dispatch(editActions.select(row))}
            isRowSelected={isSelected}
            pageSize={pageSize}
            handleFilterChange={handleFilterChangeDebounced}
            loading={isLoading}
            loadingText={"Loading Door Bindings..." + subMenuRoute}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div
              className="edit-view"
              style={{ flex: editSize, width: editSize === 0.3 ? "500px" : "1000px" }}
            >
              <EditKCEVersionCommon toggleModal={toggleModal} target="Door" />
            </div>
          </Dimmer>
        )}
      </div>
    </div>
  );
};

export default DoorVersion;
